import type { EmployerRenewalCompanyPolicy } from "Utils/types";

export const RECEIVE_ACCOUNT_ID = "EmployerApplication/RECEIVE_ACCOUNT_ID";

export const RECEIVE_COMPANY_APPLICATION_ID = "EmployerApplication/RECEIVE_COMPANY_APPLICATION_ID";

export const RECEIVE_COMPANY_POLICY_ID = "EmployerApplication/RECEIVE_COMPANY_POLICY_ID";

export const RECEIVE_APPLICATION_MENU = "EmployerApplication/RECEIVE_APPLICATION_MENU";

export const GET_APPLICATION_MENU = "EmployerApplication/GET_APPLICATION_MENU";

export const CHECK_APPLICATION_STATUS = "EmployerApplication/CHECK_APPLICATION_STATUS";

export const START_INITIAL_SYNC = "EmployerApplication/START_INITIAL_SYNC";
export const FETCH_EMPLOYEES = "EmployerApplication/FETCH_EMPLOYEES";

export const EMPLOYEES_LOADED = "EmployerApplication/EMPLOYEES_LOADED";

export const COMPANY_PROFILE_LOADED = "EmployerApplication/COMPANY_PROFILE_LOADED";

export const RECEIVE_APPLICATION_STATUS = "EmployerApplication/RECEIVE_APPLICATION_STATUS";

export const SUBMIT_DOCUMENTS = "EmployerApplication/SUBMIT_DOCUMENTS";

export const SAVE_PAYMENT_SUCCESS = "EmployerApplication/SAVE_PAYMENT_SUCCESS";

export const CHECK_PENDING_ITEMS = "EmployerApplication/CHECK_PENDING_ITEMS";

export const RECEIVE_PENDING_ITEMS = "EmployerApplication/RECEIVE_PENDING_ITEMS";

export const LOAD_OWNER_ENROLLMENT_APP = "EmployerApplication/LOAD_OWNER_ENROLLMENT_APP";

export const REPLACE_COMPANY_PROFILE = "EmployerApplication/REPLACE_COMPANY_PROFILE";

export const RECEIVE_OWNERS_AS_EMPLOYEES = "EmployerApplication/RECEIVE_OWNERS_AS_EMPLOYEES";
export const UPDATE_OWNER_AS_EMPLOYEE = "EmployerApplication/UPDATE_OWNER_AS_EMPLOYEE";

export const UPDATE_COST_ESTIMATION_EMPLOYEES = "EmployerApplication/UPDATE_COST_ESTIMATION_EMPLOYEES";
export const UPDATE_REQUESTED_LIFE_PLANS_TO_QUOTE = "EmployerApplication/UPDATE_REQUESTED_LIFE_PLANS_TO_QUOTE";

export const receiveAccountId = (accountId) => ({
  type: RECEIVE_ACCOUNT_ID,
  payload: accountId,
});

export const receiveCompanyPolicyId = (response) => ({
  type: RECEIVE_COMPANY_POLICY_ID,
  payload: response,
});

export const getApplicationMenuState = () => ({
  type: GET_APPLICATION_MENU,
});

export const fetchEmployees = () => ({
  type: FETCH_EMPLOYEES,
});

export const receiveApplicationMenu = (response) => ({
  type: RECEIVE_APPLICATION_MENU,
  payload: response,
});

export const checkApplicationStatus = () => ({
  type: CHECK_APPLICATION_STATUS,
});

export const receiveApplicationStatus = (response) => ({
  type: RECEIVE_APPLICATION_STATUS,
  payload: response,
});

export const submitDocuments = (history) => ({
  type: SUBMIT_DOCUMENTS,
  payload: {
    history,
  },
});

export const receivePendingItems = (response) => ({
  type: RECEIVE_PENDING_ITEMS,
  payload: response,
});

export const loadOwnerEnrollmentApp = () => ({
  type: LOAD_OWNER_ENROLLMENT_APP,
});

export const replaceCompanyProfile = (companyProfile) => ({
  type: REPLACE_COMPANY_PROFILE,
  payload: companyProfile,
});

export const receiveOwnersAsEmployees = (ownersAsEmployees) => ({
  type: RECEIVE_OWNERS_AS_EMPLOYEES,
  payload: ownersAsEmployees,
});

export const updateOwnersAsEmployees = (payload) => ({
  type: UPDATE_OWNER_AS_EMPLOYEE,
  payload,
});

export const updateCostEstimationEmployees = (payload) => ({
  type: UPDATE_COST_ESTIMATION_EMPLOYEES,
  payload,
});

export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const DELETING_EMPLOYEE = "DELETING_EMPLOYEE";
export const REPLACE_EMPLOYEES = "add_employees/REPLACE_EMPLOYEES";
export const DELETED_EMPLOYEE = "DELETED_EMPLOYEE";
export const SEND_REMINDER_EMAIL = "SEND_REMINDER_EMAIL";
export const UPLOADING_EMPLOYEE = "UPLOADING_EMPLOYEE";
export const UPLOADED_EMPLOYEE = "UPLOADED_EMPLOYEE";
export const ADD_ANOTHER_EMPLOYEE = "ADD_ANOTHER_EMPLOYEE";
export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const EDITING_EMPLOYEE = "EDITING_EMPLOYEE";
export const EDITED_EMPLOYEE = "EDITED_EMPLOYEE";
export const CANCEL_EDIT_EMPLOYEE = "CANCEL_EDIT_EMPLOYEE";
export const SET_EDIT_EMPLOYEE = "SET_EDIT_EMPLOYEE";
export const SET_EDIT_EMPLOYEE_FIELDS = "SET_EDIT_EMPLOYEE_FIELDS";
export const CLEAR_EDIT_EMPLOYEE_FIELDS = "CLEAR_EDIT_EMPLOYEE_FIELDS";
export const UPLOAD_EMPLOYEE_ERROR = "UPLOAD_EMPLOYEE_ERROR";

export const createEmployee = () => ({
  type: CREATE_EMPLOYEE,
});

export const deleteEmployee = (hash_id) => ({
  type: DELETE_EMPLOYEE,
  hash_id,
});

export const addAnotherEmployee = () => ({
  type: ADD_ANOTHER_EMPLOYEE,
});

export const clearEditEmployeeFields = () => ({
  type: CLEAR_EDIT_EMPLOYEE_FIELDS,
});

export const cancelEditEmployee = () => ({
  type: CANCEL_EDIT_EMPLOYEE,
});

export const editEmployee = (hash_id) => ({
  type: EDIT_EMPLOYEE,
  hash_id,
});

export const setEditEmployee = (hash_id) => ({
  type: SET_EDIT_EMPLOYEE,
  hash_id,
});

export const replaceEmployees = (employees) => ({
  type: REPLACE_EMPLOYEES,
  payload: employees,
});

export function updateRequestedLifePlansToQuote(payload) {
  return { type: UPDATE_REQUESTED_LIFE_PLANS_TO_QUOTE, payload };
}

export const RECEIVE_COMPANY_POLICY = "EmployerRenewalApplication/RECEIVE_COMPANY_POLICY";
export const INITIAL_STATE_LOADED = "EmployerRenewalApplication/INITIAL_STATE_LOADED";

export const receiveCompanyPolicy = (response: EmployerRenewalCompanyPolicy) => ({
  type: RECEIVE_COMPANY_POLICY,
  payload: response,
});

export const STEP_COMPLETED = "EmployerRenewalApplication/STEP_COMPLETED";

export type StepName = "companyInformation" | "coverageOptions" | "openEnrollment" | "sign" | "documentUpload";

export type StepCompletedAction = {
  type: typeof STEP_COMPLETED;
  payload: StepName;
};

export const stepCompleted = (step: StepName) => ({
  type: STEP_COMPLETED,
  payload: step,
});
